import { Card, Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ForgotPasswordForm } from "../../Components/AuthForms";
import { getPageMetaData } from "../../Utils/meta-data";
import { useAppContext } from "../../Context/AppContext/AppContext";
import PageMetadata from "../../Components/PageMetaData/PageMetaData";
import TransitionWrapper from "../../Components/TransitionWrapper";
import "./index.scss";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { organization } = useAppContext();

  const handleBackToSignIn = () => {
    navigate("/sign-in");
  };

  const handleSuccess = () => {
    navigate("/");
  };

  const meta = organization
    ? getPageMetaData("forgotpassowrd", { organization })
    : getPageMetaData("forgotpassowrd");

  return (
    <>
      <PageMetadata title={meta.title} description={meta.description} />
      <TransitionWrapper transitionType="slide-up" transitionDuration={200}>
        <div className="forgot-password-container">
          <Flex className="signin" align="start" justify="center">
            <Card
              className="card"
              style={{ maxWidth: 360, width: "100%" }}
              bordered
              title={
                <Typography.Title level={4} style={{ margin: 0 }}>
                  Forgot Password
                </Typography.Title>
              }
            >
              <ForgotPasswordForm
                onBackToSignIn={handleBackToSignIn}
                onSuccess={handleSuccess}
              />
            </Card>
          </Flex>
        </div>
      </TransitionWrapper>
    </>
  );
};

export default ForgotPassword;
